<template>
  <div class="boxsizing">
    <div class="materialbox-header auto">
      <div class="search-input fr">
        <el-button type="primary" @click="searchFn" size="small">搜索</el-button>
      </div>
      <div class="search-input fr">
        <el-input v-model.trim="materialArr[curType].keywords" clearable placeholder="请输入内容" size="small"></el-input>
      </div>
      <div class="date-picker fr">
        <dates-picker v-model="materialArr[curType].date" size="small"></dates-picker>
      </div>
    </div>
    <div class="materialbox-body auto">
      <div class="materialtags auto">
        <ul>
          <li v-for="(item, index) in materialArr" :key="index" v-if="!type || (type && type.indexOf(index) > -1)" :class="curType === index ? 'cur' : ''" @click="curType = index">{{item.name}}</li>
        </ul>
      </div>
      <div class="materialcon auto" v-loading="loading">
        <div class="materialtext auto" v-if="curType === 'local_text' || curType === 'text'">
          <div class="textleft auto boxsizing fl">
            <div class="textleftheader auto">
              <span class="boxsizing" :class="textTag === 1 && 'cur'" @click="changeTextTag(1)">历史文本</span>
              <span class="boxsizing" :class="textTag === 2 && 'cur'" @click="changeTextTag(2)">编辑文本</span>
            </div>
            <div class="textleftcontent auto">
              <div class="textlist auto" v-if="textTag === 1">
                <div class="textlistbox auto">
                  <el-checkbox-group v-model="textlist" size="small" ref="checkboxgroup" v-loading="!initText">
                    <p v-for="(item, index) in materialArr['local_text'].data" :key="index"><el-checkbox :label="item.id"><template><div style="width:1px;height:1px;overflow:hidden;"></div></template></el-checkbox><span class="textspan ellipsis" :class="curTextId === item.id ? 'cur' : ''" @click="previewText(index, item.id)">{{item.remark}}</span></p>
                  </el-checkbox-group>
                </div>
                <div v-if="materialArr[curType].dataNum > pageSize" class="main-page">
                  <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page="materialArr[curType].currentPage"
                    :page-size="pageSize"
                    layout="total, prev, pager, next"
                    :total="materialArr[curType].dataNum">
                  </el-pagination>
                </div>
              </div>
              <div class="textedit auto" v-else>
                <el-input type="textarea" :rows="17" ref="content" class="editTextarea" v-model="textarea"></el-input>
                <div class="tips" @click="tipsclick" v-show="textarea === ''">
                  使用指南：<br>
                  1.请自由的输入文字<br>
                  2.支持回车换行<br>
                  3.插入文字链接请点击下方按钮，并在插入的链接模板中替换跳转链接及跳转文字<br>
                  <!-- 按照&lt;a href='这里输入跳转链接'>这里输入显示文字&lt;/a>的格式录入 -->
                  4.可在右侧实时预览效果
                </div>
                <div class="texteditbtn auto">
                  <el-button @click="addlink" size="small" class="fl">插入链接</el-button>
                  <el-button @click="addminilink" size="small" class="fl">插入小程序链接</el-button>
                  <el-button @click="handleText" size="small" type="primary" class="fr">保存</el-button>
                  <el-button @click="resetText" size="small" class="fr">重置</el-button>
                </div>
              </div>
            </div>
          </div>
          <div class="textright auto boxsizing fl">
            <div class="textrightheader auto">
              预览区
            </div>
            <div class="textrightcontent auto previewbox mpreplytext" v-html="curText.replace(/\n/g, '<br>').replace(/  /g, '&nbsp;&nbsp;')"></div>
          </div>
        </div>
        <div class="materialimagetext auto" v-else>
          <div class="materialconbox auto masonry boxsizing">
            <div class="list-box auto boxsizing" :class="item.choose ? 'list-box-cur' : ''" v-for="(item, index) in materialArr[curType].data" :key="index">
              <div v-if="curType === 'mpnews'">
                <div class="listbox-top">
                  <dl class="noposter" v-if="!!!item[0].cover">
                    <dt>{{item[0].title}}</dt>
                    <dd>{{item[0].description}}</dd>
                  </dl>
                  <div class="hasposterBox" v-else>
                    <dl class="hasposter">
                      <dt>{{item[0].title}}</dt>
                      <dd><img :src="item[0].cover" alt=""></dd>
                    </dl>
                  </div>
                  <a :href="item[0].media_url" target="_blank"><span>预览</span></a>
                </div>
                <div class="listbox-item" v-if="item.length > 1 && index2 > 0" v-for="(item2, index2) in item" :key="index2">
                  <div class="listbox-itembox">
                    <dl>
                      <dt>{{item2.title}}</dt>
                      <dd><img :src="item2.cover" v-if="item2.cover" alt=""></dd>
                    </dl>
                    <a :href="item2.media_url" target="_blank"><span>预览</span></a>
                  </div>
                </div>
              </div>
              <div v-else-if="curType === 'article'">
                <div class="listbox-top">
                  <dl class="noposter" v-if="!!!item.content.news_item[0].thumb_url">
                    <dt>{{item.content.news_item[0].title}}</dt>
                    <dd>{{item.content.news_item[0].digest}}</dd>
                  </dl>
                  <div class="hasposterBox" v-else>
                    <dl class="hasposter">
                      <dt>{{item.content.news_item[0].title}}</dt>
                      <dd><img :src="item.content.news_item[0].thumb_url" alt=""></dd>
                    </dl>
                  </div>
                  <a :href="item.content.news_item[0].url" target="_blank"><span>预览</span></a>
                </div>
                <div class="listbox-item" v-if="item.content.news_item.length > 1 && index2 > 0" v-for="(item2, index2) in item.content.news_item" :key="index2">
                  <div class="listbox-itembox">
                    <dl>
                      <dt>{{item2.title}}</dt>
                      <dd><img :src="item2.thumb_url" v-if="item2.thumb_url" alt=""></dd>
                    </dl>
                    <a :href="item2.url" target="_blank"><span>预览</span></a>
                  </div>
                </div>
              </div>
              <div v-else-if="curType === 'news'">
                <div class="listbox-top">
                  <dl class="noposter" v-if="!!!item.content.articles[0].picurl">
                    <dt>{{item.content.articles[0].title}}</dt>
                    <dd>{{item.content.articles[0].description}}</dd>
                  </dl>
                  <div class="hasposterBox" v-else>
                    <dl class="hasposter">
                      <dt>{{item.content.articles[0].title}}</dt>
                      <dd><img :src="item.content.articles[0].picurl" alt=""></dd>
                    </dl>
                  </div>
                  <a :href="item.content.articles[0].url" target="_blank"><span>预览</span></a>
                </div>
                <div class="listbox-item" v-if="item.content.articles.length > 1 && index2 > 0" v-for="(item2, index2) in item.content.articles" :key="index2">
                  <div class="listbox-itembox">
                    <dl>
                      <dt>{{item2.title}}</dt>
                      <dd><img :src="item2.picurl" v-if="item2.picurl" alt=""></dd>
                    </dl>
                    <a :href="item2.url" target="_blank"><span>预览</span></a>
                  </div>
                </div>
              </div>
              <div v-else-if="curType === 'voice'">
                <div class="listbox-item" style="margin-top: 0px;">
                  <div class="listbox-itembox">
                    <dl>
                      <dt>{{item.title}}</dt>
                      <dd><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABUCAMAAAArteDzAAAAaVBMVEUAAAAarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRlIa6J1AAAAInRSTlMA9wYa38QR7ZJnMK1IIqBsO3fXDbSGQudZz5fKpV0rfbpRlHIjYQAAA35JREFUWMPFWduyqjAMDS0tgtwEFBGv/P9Hntmh3cWDTYsMs/Oio3SRy0qapuCU7PXIRdUGQxCFncgfrwzWCb/l4TCTML/xbxFlIQariEJ+AZnkwUBKkCdLIZvBQ5olsPw61Uhc4vTOa4Ca39P4IqYWXH2dyw5mWXUs2ez/8liZVx6YD2bW6wXRzmpesov0U70HxW5azTBmpD1xqJW9uUzfaS0Lp1ms0Nru6Nfv9WPSi8lahT2BKoWyvARPKZUPhLRiduq9ckHaKds6y5pa6XmARXJQutaEP4MzLJTzyJfmk193I2YKiyUdUXcf+OnCdKPO+JqNvxO2kx4YNcr+c2jvjpE7Wv27W4uRS/C1jFEu3mpdhJyX34PWISY3ByNj/SxhhZRjfZ0UMkUJt3Bxx08rJU2xbFB16YEZDiG3JSy6sHlXNPbCHIbOVpHiN1VzjBLzKOCkmxjGKld6B4oNbjkiqi3rkJeBNN8jBj7SUEaxyGgnjE1OkS0mHkUAgd5X/qWF80mWR7PaOY0410GrnHHXVHpSqlZII521RzeXqtpkTkgEEitIiwF1YeLDJgQnIldbgAx5wMBj5z4br+aWB5GdGbxUxGjUp6ESLmxhJsaMFzx+Pi5+VIpN6bTUlcvPfw/InXlvjO5MjsdE/ucg6DjxRlEJY4Wb0J1IlnR0ZoXGEHF/6l1I68d+vj3ho9xH0mO+cjumNiMxvg/tTOWYcIAkqCl+XjRbtH7CHv4aCQrIQIui3TCxNPyN1BMXfhQFFxCgJ/yzmYAaTpGgEZpPoOq60GJctfkRaX5IBApRVTNTm/TvnYHqCEoh6kMzUCuNxnUUpVzkB/2+/Pc5iTpT5PdNUx78FrMT6kymqbugmEpxNZU4JXaph7v0GbOGxJQ3SZU+ryINSWT8iAt6skg7txPD1wCJN/rrQG0nZuNzo54nHQOnNj6zRTtRj5Pe5klu0d7NBGTThvFENhNE20NQS5BtD9GgUdQqyQZtaSuZ4bIr1fUGcmHTCz1SRpJNL9GeE3xNHe35/CDhRj04DhLzI48b9eI48mxxONvyGLn+wGtsLTY5mm87RFg/7jhNxh3bD2aANWtHSFsOu7Yfy60fIG4/6lw/lN14fOwedJdWXxKD7m1H8u7LAwZMZsn88mCDa46/v5DZ6OoIhcf7dg7Y7mPalb7XcVEwDEFU+V3H/QOplcP+ctPpgwAAAABJRU5ErkJggg==" alt=""></dd>
                    </dl>
                    <a :href="item.url" target="_blank"><span>预览</span></a>
                  </div>
                </div>
              </div>
              <div v-else-if="curType === 'music'">
                <div class="listbox-item" style="margin-top: 0px;">
                  <div class="listbox-itembox">
                    <dl>
                      <dt>{{item.content.title}}</dt>
                      <dd><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABUCAMAAAArteDzAAAAaVBMVEUAAAAarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRkarRlIa6J1AAAAInRSTlMA9wYa38QR7ZJnMK1IIqBsO3fXDbSGQudZz5fKpV0rfbpRlHIjYQAAA35JREFUWMPFWduyqjAMDS0tgtwEFBGv/P9Hntmh3cWDTYsMs/Oio3SRy0qapuCU7PXIRdUGQxCFncgfrwzWCb/l4TCTML/xbxFlIQariEJ+AZnkwUBKkCdLIZvBQ5olsPw61Uhc4vTOa4Ca39P4IqYWXH2dyw5mWXUs2ez/8liZVx6YD2bW6wXRzmpesov0U70HxW5azTBmpD1xqJW9uUzfaS0Lp1ms0Nru6Nfv9WPSi8lahT2BKoWyvARPKZUPhLRiduq9ckHaKds6y5pa6XmARXJQutaEP4MzLJTzyJfmk193I2YKiyUdUXcf+OnCdKPO+JqNvxO2kx4YNcr+c2jvjpE7Wv27W4uRS/C1jFEu3mpdhJyX34PWISY3ByNj/SxhhZRjfZ0UMkUJt3Bxx08rJU2xbFB16YEZDiG3JSy6sHlXNPbCHIbOVpHiN1VzjBLzKOCkmxjGKld6B4oNbjkiqi3rkJeBNN8jBj7SUEaxyGgnjE1OkS0mHkUAgd5X/qWF80mWR7PaOY0410GrnHHXVHpSqlZII521RzeXqtpkTkgEEitIiwF1YeLDJgQnIldbgAx5wMBj5z4br+aWB5GdGbxUxGjUp6ESLmxhJsaMFzx+Pi5+VIpN6bTUlcvPfw/InXlvjO5MjsdE/ucg6DjxRlEJY4Wb0J1IlnR0ZoXGEHF/6l1I68d+vj3ho9xH0mO+cjumNiMxvg/tTOWYcIAkqCl+XjRbtH7CHv4aCQrIQIui3TCxNPyN1BMXfhQFFxCgJ/yzmYAaTpGgEZpPoOq60GJctfkRaX5IBApRVTNTm/TvnYHqCEoh6kMzUCuNxnUUpVzkB/2+/Pc5iTpT5PdNUx78FrMT6kymqbugmEpxNZU4JXaph7v0GbOGxJQ3SZU+ryINSWT8iAt6skg7txPD1wCJN/rrQG0nZuNzo54nHQOnNj6zRTtRj5Pe5klu0d7NBGTThvFENhNE20NQS5BtD9GgUdQqyQZtaSuZ4bIr1fUGcmHTCz1SRpJNL9GeE3xNHe35/CDhRj04DhLzI48b9eI48mxxONvyGLn+wGtsLTY5mm87RFg/7jhNxh3bD2aANWtHSFsOu7Yfy60fIG4/6lw/lN14fOwedJdWXxKD7m1H8u7LAwZMZsn88mCDa46/v5DZ6OoIhcf7dg7Y7mPalb7XcVEwDEFU+V3H/QOplcP+ctPpgwAAAABJRU5ErkJggg==" alt=""></dd>
                    </dl>
                    <a :href="item.content.musicurl" target="_blank"><span>预览</span></a>
                  </div>
                </div>
              </div>
              <div v-else-if="curType === 'video'">
                <div class="listbox-item" style="margin-top: 0px;">
                  <div class="listbox-itembox">
                    <dl>
                      <dt>{{item['content'].title}}</dt>
                      <dd><img src="data:image/svg+xml;charset=utf8, <svg width='45' height='45' viewBox='0 0 45 45' xmlns='http://www.w3.org/2000/svg'><g fill='none' fill-rule='evenodd'><circle stroke='%23FFF' stroke-width='2.3' cx='22.5' cy='22.5' r='21.35'/><g fill='%23FFF'><path d='M16.13 17h10.74c.624 0 1.13.506 1.13 1.13v8.74A1.13 1.13 0 0 1 26.87 28H16.13A1.13 1.13 0 0 1 15 26.87v-8.74c0-.624.506-1.13 1.13-1.13zM29 23.72v-2.388c1.158-1.063 2.91-2.929 3.011-3.06.509-.66.989.101.989 0v8.521c0-.15-.477.533-.989 0-.117-.122-1.847-2.008-3.011-3.074zm-1-1.181z'/></g></g></svg>" alt=""></dd>
                    </dl>
                    <a :href="item['content'].media_url" target="_blank"><span>预览</span></a>
                  </div>
                </div>
              </div>
              <div v-else-if="curType === 'image'">
                <div class="listbox-top">
                  <div class="hasposterBox">
                    <dl class="hasposter">
                      <dt>{{item.title}}</dt>
                      <dd><img :src="item.url" alt=""></dd>
                    </dl>
                  </div>
                </div>
              </div>
              <div v-else-if="curType === 'local_miniprogrampage'">
                <div class="texttitle miniimgtitle gray80">
                  {{item.remark}}
                </div>
                <div class="miniimgbox gray80">
                  <img src="../../../assets/opacity.png" alt="">
                  <img :src="item.content.thumb_media_url" class="materialimg" alt="">
                </div>
              </div>
              <div class="dialogControl">
                <span v-if="item.remark" style="float: left;">
                  <el-tooltip class="tip-item" effect="dark" placement="top">
                    <div slot="content">{{item.remark}}</div>
                    <i class="el-icon-question" small></i>
                  </el-tooltip>
                </span>
                <a href="javascript:;" class="alink color-red" v-if="item.choose" @click="deleteMaterial(index)">删除</a>
                <a href="javascript:;" class="alink" v-else @click="chooseMaterial(index)">选择</a>
              </div>
            </div>
          </div>
          <div class="materialpage auto main-page">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="materialArr[curType].currentPage"
              :page-size="pageSize"
              layout="total, prev, pager, next"
              :total="materialArr[curType].dataNum">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="填写标题" :modal="false" :modal-append-to-body="false" :visible="titleVisible" width="70%">
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button @click="saveText" type="primary" size="small">确定</el-button>
          <el-button @click="cancelTitle" size="small">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { Mp } from '@/model'
export default {
  name: 'MaterialBox',
  props: [
    'type',
    'value'
  ],
  data () {
    return {
      loading: false,
      date: [],
      search: '',
      textlist: [],
      curType: 'local_text',
      materialArr: {
        local_text: {
          name: '本地文本',
          date: [],
          keywords: '',
          data: [],
          dataNum: 0,
          currentPage: 1
        },
        news: {
          name: '本地图文',
          date: [],
          keywords: '',
          data: [],
          dataNum: 0,
          currentPage: 1
        },
        mpnews: {
          name: '微信图文',
          date: [],
          keywords: '',
          data: [],
          dataNum: 0,
          currentPage: 1
        },
        article: {
          name: '已发布文章',
          date: [],
          keywords: '',
          data: [],
          dataNum: 0,
          currentPage: 1
        },
        image: {
          name: '微信图片',
          date: [],
          keywords: '',
          data: [],
          dataNum: 0,
          currentPage: 1
        },
        voice: {
          name: '微信语音',
          date: [],
          keywords: '',
          data: [],
          dataNum: 0,
          currentPage: 1
        },
        music: {
          name: '本地音乐',
          date: [],
          keywords: '',
          data: [],
          dataNum: 0,
          currentPage: 1
        },
        video: {
          name: '本地视频',
          date: [],
          keywords: '',
          data: [],
          dataNum: 0,
          currentPage: 1
        },
        local_miniprogrampage: {
          name: '本地小程序',
          date: [],
          keywords: '',
          data: [],
          dataNum: 0,
          currentPage: 1
        }
      },
      textTag: 1,
      curTextId: '',
      curText: '',
      textarea: '',
      positionStart: '',
      positionEnd: '',
      form: {
        title: ''
      },
      rules: {
        title: [
          { required: true, message: '请填写标题', trigger: 'blur' }
        ]
      },
      titleVisible: false,
      pageSize: 11,
      currentPage: 1,
      content: this.value,
      isDeleteText: false,
      initText: false
    }
  },
  watch: {
    'textarea': function (val) {
      this.curText = val
    },
    'textTag': function (newval, oldval) {
      if (newval === 1 && oldval === 2 && this.textarea.trim()) {
        this.textTag = 2
        this.$confirm('当前有未保存的内容，离开将清空内容，确定要离开吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.textarea = ''
          this.textTag = 1
        }).catch(() => {
        })
      }
      if (newval === 2 && oldval === 1) {
        this.curText = ''
        this.curTextId = ''
      }
    },
    'curType': function (val) {
      // console.log(val)
      this.materialArr[val].keywords = ''
      this.materialArr[val].date = []
      this.searchFn()
    },
    'textlist': function (newval, oldval) {
      if (this.initText) {
        if (newval.length > oldval.length) { // 新增
          let itemContent = newval[newval.length - 1]
          let mIndex = this.materialArr[this.curType]['data'].findIndex((value, index, arr) => {
            return value.id === itemContent
          })
          this.materialArr[this.curType]['data'][mIndex]['type'] = this.curType
          this.materialArr[this.curType]['data'][mIndex]['choose'] = true
          let item = Object.assign({}, this.materialArr[this.curType]['data'][mIndex])
          // console.log(item.remark)
          this.content.push(item)
        } else { // 删除
          if (this.isDeleteText) {
            this.isDeleteText = false
          } else {
            // console.log('oldval', oldval)
            // console.log('newval', newval)
            // var newArr = Object.assign([], oldval)
            // for (let i = 0; i < oldval.length; i++) {
            //   for (let o = 0; o < newval.length; o++) {
            //     if (oldval[i] === newval[o]) {
            //       newArr.splice(o, 1)
            //     }
            //   }
            // }
            // let a = new Set(oldval)
            // let b = new Set(newval)
            let newArr = oldval.filter(x => !newval.includes(x))
            let item = newArr[0]
            let nIndex = this.content.findIndex((value, index, arr) => {
              return value.id === item
            })
            this.content.splice(nIndex, 1)
            let mIndex = this.materialArr[this.curType]['data'].findIndex((value, index, arr) => {
              return value.id === item
            })
            this.materialArr[this.curType]['data'][mIndex]['type'] = this.curType
            this.materialArr[this.curType]['data'][mIndex]['choose'] = false
          }
        }
        this.initText = false
      }
      this.materialArr = Object.assign({}, this.materialArr)
    },
    'content': function (val) {
      if (!val.length) {
        this.isDeleteText = true
        this.textlist = []
      }
      let newTextList = Object.assign([], this.textlist)
      for (let i = 0; i < newTextList.length; i++) {
        for (let o = 0; o < this.content.length; o++) {
          if (newTextList[i] === this.content[o].id) {
            newTextList.splice(i, 1)
          }
        }
      }
      if (newTextList[0]) {
        this.isDeleteText = true
        this.curType = 'local_text'
        let tIndex = this.textlist.findIndex((value, index, arr) => {
          return value === newTextList[0]
        })
        let mIndex = this.materialArr[this.curType]['data'].findIndex((value, index, arr) => {
          return value.id === newTextList[0]
        })
        this.materialArr[this.curType]['data'][mIndex]['type'] = this.curType
        this.materialArr[this.curType]['data'][mIndex]['choose'] = false
        this.textlist.splice(tIndex, 1)
      }
      this.initChoose()
      this.$emit('input', val)
    },
    'value': function (val) {
      this.content = val
    }
  },
  methods: {
    async getMaterialList (type = this.curType, cb) {
      this.loading = true
      let res = null
      if (type !== 'article') {
        res = await Mp.System.getMaterialList({
          type: type,
          create_time: this.materialArr[type].date,
          page_size: this.pageSize,
          page: this.materialArr[type].currentPage,
          search: this.materialArr[type].keywords
        })
      } else {
        res = await Mp.Material.getList({
          material_type: type,
          create_time: this.materialArr[type].date,
          limit: this.pageSize,
          page: this.materialArr[type].currentPage,
          search: this.materialArr[type].keywords
        })
      }
      if (!res.err_code) {
        if (type !== 'article') {
          this.materialArr[type].data = res['data']['list']
          this.materialArr[type].dataNum = res['data']['total']
        } else {
          this.materialArr[type].data = res['list']
          this.materialArr[type].dataNum = res['count']
        }
        this.initChoose()
        if (cb) { cb() }
      }
      this.loading = false
    },
    initChoose () {
      for (let key in this.materialArr) {
        for (let _key in this.materialArr[key]['data']) {
          this.materialArr[key]['data'][_key]['choose'] = false
        }
      }
      if (this.content.length) {
        this.initText = false
        this.textlist = []
        var newTextList = []
        for (let key in this.content) {
          let item = this.content[key]
          let chooseItem
          let id = item.article_id || (item[0] && item[0].article_id) || item.media_id || (item[0] && item[0].media_id) || item.id
          if (this.curType === 'news' || this.curType === 'local_text' || this.curType === 'local_miniprogrampage' || this.curType === 'music' || this.curType === 'video') {
            chooseItem = this.materialArr[this.curType].data.find(newitem => {
              return newitem.id === id
            })
          } else if (this.curType === 'article') {
            chooseItem = this.materialArr[this.curType].data.find(newitem => {
              return newitem.article_id === id
            })
          } else {
            chooseItem = this.materialArr[this.curType].data.find(newitem => {
              let mediaId = this.curType === 'mpnews' ? newitem[0].media_id : newitem.media_id
              return mediaId === id
            })
          }
          if (chooseItem) {
            chooseItem['choose'] = true
            chooseItem['type'] = this.curType
          }
          if (this.content[key].type === 'local_text') {
            newTextList.push(this.content[key]['id'])
          }
        }
        this.textlist = newTextList
      }
      setTimeout(() => {
        this.initText = true
      }, 500)
    },
    previewText (index, id) {
      this.curText = this.materialArr['local_text']['data'][index]['content']
      this.curTextId = id
    },
    changeTextTag (value) {
      this.textTag = value
    },
    addlink () {
      this.positionStart = this.$refs['content'].$refs['textarea'].selectionStart
      this.positionEnd = this.$refs['content'].$refs['textarea'].selectionEnd
      var linkstr = '<a href=\'这里写跳转链接\'>这里输入显示文字</a>'
      this.textarea = this.textarea.substring(0, this.positionStart) + linkstr + this.textarea.substring(this.positionEnd, this.textarea.length)
    },
    addminilink () {
      this.positionStart = this.$refs['content'].$refs['textarea'].selectionStart
      this.positionEnd = this.$refs['content'].$refs['textarea'].selectionEnd
      var linkstr = '<a href=\'\' data-miniprogram-appid=\'这里写小程序APPID\' data-miniprogram-path=\'这里写小程序页面地址\'>这里输入显示文字</a>'
      this.textarea = this.textarea.substring(0, this.positionStart) + linkstr + this.textarea.substring(this.positionEnd, this.textarea.length)
    },
    tipsclick () {
      this.$refs['content'].$refs['textarea'].focus()
    },
    handleText () {
      if (this.textarea.trim()) {
        this.titleVisible = true
      } else {
        this.$message.error('请填写内容')
      }
    },
    resetText () {
      this.textarea = ''
    },
    cancelTitle () {
      this.form.title = ''
      this.titleVisible = false
    },
    saveText () {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          var content = this.textarea
          let res = await Mp.Reply.saveLocalMaterialInfo({
            type: 'local_text',
            content: content,
            remark: this.form.title
          })
          if (res.err_code === 0) {
            this.$message.success('提交成功')
            this.cancelTitle()
            this.resetText()
            this.textTag = 1
            this.initText = true
            this.getMaterialList(this.curType, () => {
              this.$nextTick(() => {
                setTimeout(() => {
                  let checkbox = this.$refs['checkboxgroup'].$children.find(item => {
                    return item.label === res.err_msg
                  })
                  // console.log(checkbox)
                  checkbox.$el.click()
                }, 500)
                // this.textlist.push(res.err_msg)
              })
            })
          } else {
            this.$message.error(res.err_msg)
          }
        }
      })
    },
    handleCurrentChange (val) {
      this.materialArr[this.curType].currentPage = val
      this.getMaterialList(this.curType)
    },
    searchFn () {
      this.materialArr[this.curType].currentPage = 1
      this.getMaterialList()
    },
    chooseMaterial (index) {
      // console.log(this.materialArr)
      // var item = this.materialArr[this.curType]['data'][index]
      // console.log(333, JSON.stringify(item))
      this.materialArr[this.curType]['data'][index]['type'] = this.curType
      this.materialArr[this.curType]['data'][index]['choose'] = true
      // item = JSON.parse(JSON.stringify(item))
      // this.materialArr[this.curType]['data'][index] = item
      this.materialArr = JSON.parse(JSON.stringify(this.materialArr))
      // console.log(this.materialArr)
      if (this.curType === 'article') {
        // this.materialArr[this.curType]['data'][index][0] = this.materialArr[this.curType]['data'][index]
        this.materialArr[this.curType]['data'][index]['id'] = this.materialArr[this.curType]['data'][index]['article_id']
        this.content.push([this.materialArr[this.curType]['data'][index]])
        this.content[this.content.length - 1]['type'] = this.curType
        this.content[this.content.length - 1]['choose'] = true
        this.content[this.content.length - 1]['id'] = this.materialArr[this.curType]['data'][index]['article_id']
      } else if (this.curType === 'mpnews') {
        this.content.push(this.materialArr[this.curType]['data'][index])
      } else {
        this.content.push(this.materialArr[this.curType]['data'][index])
      }
      // this.content = JSON.parse(JSON.stringify(this.content))
    },
    deleteMaterial (index) {
      var nIndex = null
      for (let key in this.content) {
        let item = this.content[key]
        let chooseItemId = null
        let id = item.media_id || (item[0] && item[0].media_id) || item.id
        if (this.curType === 'news' || this.curType === 'local_text' || this.curType === 'local_miniprogrampage' || this.curType === 'music' || this.curType === 'video') {
          chooseItemId = this.materialArr[this.curType].data[index].id
        } else if (this.curType === 'article') {
          chooseItemId = this.materialArr[this.curType].data[index].article_id
        }  else {
          chooseItemId = this.curType === 'mpnews' ? this.materialArr[this.curType].data[index][0].media_id : this.materialArr[this.curType].data[index].media_id
        }
        if (chooseItemId && id === chooseItemId) {
          nIndex = key
        }
      }
      // console.log(nIndex)
      this.content.splice(nIndex, 1)
      this.materialArr[this.curType]['data'][index]['choose'] = false
      this.materialArr = Object.assign({}, this.materialArr)
    }
  },
  created () {
  },
  mounted () {
    this.getMaterialList()
  }
}
</script>
<style scoped>
.materialbox-header {
  border-bottom: 2px solid #eee;
  padding-bottom: 15px;
}
.search-input {
  margin-left: 10px;
}
.materialbox-body {
  position: relative;
  color: #aeaeae;
}
.materialtags {
  position: absolute;
  left: 0;
  top: 0;
  width: 120px;
  padding-top: 30px;
}
.materialtags ul li {
  width: 100%;
  height: 44px;
  line-height: 44px;
  margin-top: 5px;
  text-indent: 20px;
  color: #aeaeae;
  cursor: pointer;
}
.materialtags ul li:hover, .materialtags ul li.cur {
  background: #f0f5ff;
  color: #67bcfc;
}
.materialcon {
  margin-left: 120px;
  border-left: 2px solid #eee;
  min-height: 470px;
}
.materialtext {
  width: 100%;
}
.textleft {
  width: 50%;
  border-right: 2px solid #eee;
  height: 500px;
}
.textright {
  width: 50%;
  height: 500px;
}
.textleftheader {
  width: 100%;
  border-bottom: 1px solid #eee;
  height: 44px;
  line-height: 44px;
}
.textleftheader span {
  width: 50%;
  float: left;
  text-align: center;
  cursor: pointer;
}
.textleftheader span:nth-child(1) {
  border-right: 1px solid #eee;
}
.textleftheader span.cur {
  color: #67bcfc;
}
.textrightheader {
  width: 100%;
  border-bottom: 1px solid #eee;
  height: 44px;
  line-height: 44px;
  text-align: center;
}
.textrightcontent {
  padding: 20px;
  color: #606266;
}
.textleftcontent {
  padding: 20px;
}
.textlistbox p {
  display: block;
  width: 100%;
  height: auto;
  overflow: hidden;
  height: 40px;
  line-height: 40px;
}
.textlistbox p label {
  float: left;
}
span.textspan {
  font-size: 14px;
  cursor: pointer;
  display: inline-block;
  width: 80%;
  overflow: hidden;
}
span.textspan.cur {
  color: #67bcfc;
}
.textlistbox {
  width: 100%;
  height: 400px;
  border-bottom: 1px solid #eee;
  overflow: auto;
}
.textedit {
  position: relative;
}
.texteditbtn {
  margin-top: 15px;
}
.tips {
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -100px;
  margin-top: -100px;
  font-size: 12px;
  color: #ccc;
  line-height: 20px;
  width: 200px;
}
.main-page {
  padding-top: 10px;
}

.materialconbox {
  padding-left: 15px;
  padding-top: 10px;
}
.masonry {
  width: 100%;
  height: auto;
  overflow: hidden;
}
.list-box {
  padding: 10px;
  background: #fff;
  box-shadow: 0 0 5px rgba(0,0,0,.1);
  border-radius: 5px;
  border: 1px solid #eee;
  float: left;
  height: auto;
  overflow: hidden;
  margin: 5px 0;
  width: calc(31% - 22px);
  margin-right: 3%;
}

.list-box-cur {
  border: 1px solid rgba(103, 188, 252, 0.6);
  /*box-shadow: 0 0 5px rgba(64,158,255,.1);*/
  background: rgba(240, 245, 255, 0.2);
}
.listbox-top {
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  position: relative;
}
.listbox-top dl dt {
  font-size: 16px;
}
.noposter dd {
  color: #9a9a9a;
  font-size: 12px;
  line-height: 18px;
  height: 36px;
  overflow: hidden;
  padding-top: 10px;
}
.hasposterBox {
  position: relative;
  height: auto;
  overflow: hidden;
}
.hasposter {
  position: relative;
}
.hasposter dt {
  position: absolute;
  left: 0;
  bottom: 0;
  padding: 8px 5%;
  background: rgba(0,0,0,.55);
  color: #fff;
  width: 90%;
}
.hasposter dd {
  height: 130px;
  overflow: hidden;
}
.hasposter dd img{
  width: 100%;
  display: block;
}
.listbox-top a {
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  bottom: 10px;
  background: rgba(0,0,0,.5);
  text-align: center;
  display: none;
}
.listbox-top:hover a {
  display: block;
}
.listbox-top a span {
  color: #fff;
  line-height: 20px;
  position: relative;
  top: 45%;
  /*margin-top: -10px;*/
}
.listbox-item {
  width: 100%;
  margin-top: 10px;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}
.listbox-item dl {
  width: 100%;
  height: auto;
  overflow: hidden;
  position: relative;
}
.listbox-item dl dt {
  position: absolute;
  right: 70px;
  left: 0;
  font-size: 14px;
  line-height: 20px;
  height: 60px;
  overflow: hidden;
}
.listbox-item dl dd {
  width: 60px;
  height: 60px;
  float: right;
  background: #eee;
}
.listbox-item dl dd img{
  width: 100%;
}
.listbox-itembox {
  position: relative;
}
.listbox-itembox a{
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  bottom: 0px;
  background: rgba(0,0,0,.5);
  text-align: center;
  display: none;
}
.listbox-itembox:hover a {
  display: block;
}
.listbox-itembox a span {
  color: #fff;
  line-height: 20px;
  position: relative;
  top: 30%;
  /*margin-top: -10px;*/
}
.list-box .control{
  margin-top: 10px;
  text-align: right;
}
.list-box .control a{
  color: #409EFF;
}
.dialogControl{
  padding-top: 10px;
  text-align: right;
}
.dialogControl span {
  float: left;
  font-size: 12px;
}
.dialogControl a {
  float: right;
}
.miniimgtitle {
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}
.miniimgbox {
  width: 100%;
  height: auto;
  overflow: hidden;
  position: relative;
  margin: 10px 0;
  border-bottom: 1px solid #eee;
}
.miniimgbox img {
  width: 100%;
}
.materialimg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
}
</style>
